// extracted by mini-css-extract-plugin
export var textInput = "_lu-0";